import api from "../api";

export const isOnboardingFinished = (customer: { onboarding_status: api.OnboardingStatus }) =>
  customer.onboarding_status === "NOT_SIGNED" || customer.onboarding_status === "DONE";
